import { render, staticRenderFns } from "./backstage.vue?vue&type=template&id=43232a74&scoped=true"
import script from "./backstage.vue?vue&type=script&lang=js"
export * from "./backstage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43232a74",
  null
  
)

export default component.exports